import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { LIST_STATE_KEYS } from '../../config/listStateKeys';
import { Link } from 'react-router-dom';
import { connect, useDispatch, useStore } from 'react-redux';
import { ListStateAction } from '../../actions/ListStateAction';
import { readPriorityFilter, buildPrioritySnapshotPatch } from '../../lib/listPriorityFilter';

import { RayTable, RayTreeview, AdminErrorListHeader } from '../../components/common';
import { ProductAction } from '../../actions/ProductAction';
import { ProgramConstant } from '../../actions/constants/ProgramConstant';
import CustomHeader from '../../components/common/CustomHeader';
import { useConfirmDialog } from '../../components/common/ConfirmDialog';

import { Translate as t } from '../../config/Translate';
import { applyHeaderPrefs } from '../../lib/headerPrefs';

// IMP-444 (#403): Error 도 Product 와 동일하게 dfilters 교집합이 아니라
// baseHeaderNames(기본 컬럼 name 목록)로 저장값 중 기본 컬럼을 걸러낸다.
export const computeErrorExHeader = (user, baseHeaderNames) => {
	const saved = user?.adminheaders?.errors;
	if (!saved) return [];
	if (!Array.isArray(baseHeaderNames)) return saved;
	return saved.filter(x => !baseHeaderNames.includes(x?.name));
};

// IMP-077: errfilters(서버 echo 필터, errs.priority 제외)와 priorityFilter(컴포넌트 로컬
// priority 차원)를 명시 병합하는 순수 함수. 단위 테스트 가능하도록 컴포넌트에서 분리(export).
// reducer 정상 경로에서 errfilters 는 errs.priority 가 분리·정규화된 객체이나,
// 함수 시그니처는 errfilters/priorityFilter null 입력에도 안전하도록 작성(|| {}).
export const buildErrorFilters = (errfilters, priorityFilter) => ({
	...(errfilters || {}),
	...(priorityFilter || {}),
});

const AdminErrorList = ({ su, user, GetErrorList, CloseProductError, AddErrorMailException, RemoveErrorMailException, BatchCheckMailExceptions, producterrs, filterDateOptions, producterrsmatch,
	totalproducterrcount, filterErrOptions, errfilters, errsort, companies, viewTree }) => {

	const [showModal, setShowModal] = useState(false);
	const [bulkList, setBulkList] = useState([]);
	const [bulkType, setBulkType] = useState("");

	const [header, setHeader] = useState([]);
	const [exheader, setExHeader] = useState([]);
	const [ready, setReady] = useState(false);

	const [filterData, setFilterData] = useState([]);
	const [showCHModal, setShowCHModal] = useState(false);

	const [wHg, setwHg] = useState(300);
	const [wAll, setwAll] = useState(window.innerWidth);
	const [filterCompanyId, setFilterCompanyId] = useState("");
	const [filterCompany, setFilterCompany] = useState({ name: "ALL" });
	const [mutedErrors, setMutedErrors] = useState([]);
	const dispatch = useDispatch();
	const store = useStore();
	// BUG-257: 화면 복귀 시 RayTable 이 스냅샷 filterpage 를 복원하므로 칩 초기값도 스냅샷에서 읽는다.
	const [priorityFilter, setPriorityFilterState] = useState(() => readPriorityFilter(store.getState()?.ListStateReducer?.[LIST_STATE_KEYS.ADMIN_ERROR], 'errs.priority'));
	// 칩 변경 시 RayTable 재마운트 전에 스냅샷 priority 를 새 값으로 맞춘다(안 맞추면 복원이 새 값을 덮어씀).
	const setPriorityFilter = (next) => {
		const patch = buildPrioritySnapshotPatch(store.getState()?.ListStateReducer?.[LIST_STATE_KEYS.ADMIN_ERROR], 'errs.priority', next);
		patch && dispatch(ListStateAction.Save(LIST_STATE_KEYS.ADMIN_ERROR, patch));
		setPriorityFilterState(next);
	};

	// Clear 버튼: 우선순위 칩을 All 로. 칩이 바뀌면 RayTable 이 key 로 재마운트되며 스냅샷을 복원하므로,
	// 복원이 옛 검색어·필터를 되살리지 않게 스냅샷도 함께 초기값으로 맞춘다(스냅샷 필드를 undefined 로 두면 RayTable 기본값 사용).
	const clearPriorityFilter = () => {
		if (Object.keys(priorityFilter).length === 0) return;
		const saved = store.getState()?.ListStateReducer?.[LIST_STATE_KEYS.ADMIN_ERROR]?.filterpage;
		if (saved && typeof saved === 'object') {
			dispatch(ListStateAction.Save(LIST_STATE_KEYS.ADMIN_ERROR, {
				filterpage: { ...saved, filters: buildErrorFilters(errfilters, {}), searchKey: '', filterDateOptions: [], page: 1 },
				currentPage: 1, skey: '', filters: undefined, datefilters: undefined,
			}));
		}
		setPriorityFilterState({});
	};

	const isManager = user && (user.adminType === 'S' || user.adminType === 'M');

	const buildFilters = () => buildErrorFilters(errfilters, priorityFilter);

	const filterpage = {
		filters: buildFilters(),
		filterOptions: filterErrOptions || [],
		filterDateOptions: filterDateOptions || [
			{ code: 'errs.begin', label: t('common.button.begin') },
		],
		exheader: [],
		searchCols: ['errs.code', 'model', 'option', 'sn', 'site.sitename'],
		sort: errsort || { 'errs.begin': -1 },
		searchKey: "",
		page: 1,
		itemperpage: 30
	};

	const options = {
		isShowCheckBox: true,
		showClear: true,
		search: true,
		keyCol: 'errs._id',
		defaultSort: filterpage.sort && Object.keys(filterpage.sort)[0],
		defaultSortType: filterpage.sort && Object.values(filterpage.sort)[0],
		linkto: '/Admin/AdminErrorInfo',
		linkkey: ['errs._id', 'errs.code', 'sn'],
		getList: GetErrorList,
		filterpageoption: filterpage,
		filters: filterpage.filters,
		itemperpage: filterpage.itemperpage,
		useapi: true,
		totalitemcount: totalproducterrcount,
		filterOptions: filterErrOptions
	};

	useEffect(() => {
		user.adminType != "U" && updateViewTree(true);
	}, []);

	useEffect(() => {
		setReady(header.length > 0);
	}, [header]);

	useEffect(() => {
		const baseNames = Array.isArray(AdminErrorListHeader) ? AdminErrorListHeader.map(x => x?.name) : [];
		setExHeader(computeErrorExHeader(user, baseNames));
	}, [user.adminheaders?.errors]);

	useEffect(() => {
		const composed = exheader.length > 0 ? AdminErrorListHeader.concat(exheader) : AdminErrorListHeader;
		setHeader(applyHeaderPrefs(composed, user?.adminheaders?.errors));
	}, [exheader, user?.adminheaders?.errors]);

	useEffect(() => {
		if (viewTree) {
			setwHg(300);
		} else {
			setwHg(0);
		}
	}, [viewTree]);

	const loadMuteStatus = useCallback(async () => {
		const items = producterrs.map(e => ({ sn: e.sn, errorCode: e.errs?.code }))
			.filter(i => i.sn && i.errorCode);
		if (items.length === 0) return;
		const result = await BatchCheckMailExceptions(items);
		setMutedErrors(result || []);
	}, [producterrs, BatchCheckMailExceptions]);

	// FEAT-015: 에러 목록 변경 시 mute 상태 일괄 조회
	useEffect(() => {
		if (producterrs && producterrs.length > 0) {
			loadMuteStatus();
		} else {
			setMutedErrors([]);
		}
	}, [producterrs, loadMuteStatus]);

	const isMuted = (sn, errorCode) => {
		return mutedErrors.some(m => m.sn === sn && m.errorCode === errorCode);
	};

	const onChangeTreeviewItem = (item) => {
		setFilterCompanyId({ companyId: item.id });
		setFilterCompany(item);
	}

	const checkedList = (list) => {
		setBulkList(list);
	}

	const defaultFilter = [
		{ code: "company.country", name: t('common.field.country'), type: "COUNTRY" },
		{ code: "companyId", name: t('user.type.operator'), type: "OPERATOR" },
		{ code: "codes", name: t('common.label.codes'), type: "STRING" },
		{ code: "option", name: t('common.label.option'), type: "OPTION" },
		{ code: "lastConnectedDate", name: t('common.label.lastConnectedDate'), type: "DATETIME" },
		{ code: "lastDisconnectedDate", name: t('common.label.lastDisconnectedDate'), type: "DATETIME" },
		{ code: "installedDate", name: t('common.label.installDate'), type: "DATETIME" },
		{ code: "productTWId", name: t('common.label.thingworxId'), type: "STRING" },
		{ code: "sitename", name: t('site.field.siteName'), type: "STRING" },
		{ code: "isConnected", name: t('common.label.isConnected'), type: "BOOLEAN" },
		{ code: "dim", name: t('product.field.dim'), type: "BOOLEAN" },
		{ code: "doa", name: t('product.field.doa'), type: "BOOLEAN" },
		{ code: "registerd", name: t('common.status.registered'), type: "DATETIME" },
		{ code: "manufactured", name: t('common.label.manufacturedDate'), type: "DATETIME" },
	]

	const updateViewTree = (bl) => {
		dispatch({ type: ProgramConstant.VIEWTREE, val: bl });
	}
	const toggle = [
		{ code: true, title: t('common.label.all'), filter: {} },
		{ code: false, title: t('service.label.notClosed'), filter: { 'errs.closer': null } }
	];

	const getMatchToggle = () => {
		const m = toggle.filter(x => JSON.stringify(x.filter) == JSON.stringify(producterrsmatch));
		if (m.length > 0) {
			return m[0].code;
		}
		return false;
	}

	const { confirm, dialog } = useConfirmDialog();

	const selectedClose = async () => {
		if (await confirm({ message: t('common.message.confirm.closeSelectedErrors') })) {
			for (let i = 0; i < bulkList.length; i++) {
				const sn = producterrs.find(x => x.errs._id === bulkList[i])?.sn;
				CloseProductError(sn, { errId: bulkList[i], closer: user.adminid, end: new Date().getTime() }, undefined, { silent: true });
			}
		}
	}

	const selectedMute = async () => {
		if (await confirm({ message: t('notification.email.alertMuteConfirm') })) {
			const promises = bulkList
				.map(id => producterrs.find(x => x.errs._id === id))
				.filter(e => e && !isMuted(e.sn, e.errs?.code))
				.map(e => AddErrorMailException(e.sn, e.errs.code, e.errs.description || ''));
			await Promise.all(promises);
			await loadMuteStatus();
		}
	}

	const selectedUnmute = async () => {
		if (await confirm({ message: t('common.message.confirm.unmuteMailAlerts') })) {
			const promises = bulkList
				.map(id => producterrs.find(x => x.errs._id === id))
				.filter(e => e && isMuted(e.sn, e.errs?.code))
				.map(e => RemoveErrorMailException(e.sn, e.errs.code));
			await Promise.all(promises);
			await loadMuteStatus();
		}
	}

	const handleBulkAction = (action) => {
		if (action === 'CLOSEALL') selectedClose();
		else if (action === 'MUTEALL') selectedMute();
		else if (action === 'UNMUTEALL') selectedUnmute();
	}

	// Mute 상태 표시용 데이터 가공
	const enrichedData = useMemo(() => producterrs.map(e => {
		const muted = isMuted(e.sn, e.errs?.code);
		return { ...e, mailMuted: muted, mailMutedLabel: muted ? '🔕 Muted' : '' };
	}), [producterrs, mutedErrors]);

	const bulkActions = useMemo(() => {
		const actions = [{ title: t('common.button.closeSelected'), action: "CLOSEALL" }];
		if (isManager) {
			actions.push({ title: t('notification.button.muteSelected'), action: "MUTEALL" });
			actions.push({ title: t('service.button.unmuteSelected'), action: "UNMUTEALL" });
		}
		return actions;
	}, [isManager]);

	return (
		<>
			{dialog}
			<div className="extraHeader">
				<h2 className="mb-0">{t('product.label.errorList')}
					{companies.length > 1 && <button className="btn btn-secondary btn-sm mt-0 ms-1" onClick={() => updateViewTree(!viewTree)}>
						{filterCompany.name && <>
							{filterCompany.country && "[" + filterCompany.country + "] "}{filterCompany.name}
						</>}
					</button>}
				</h2>
				<div className="ray-right">
					<button onClick={() => setShowCHModal(true)} className="btn btn-sm mt-0">
						<ion-icon name="options-outline"></ion-icon> {t('common.label.customHeaders')}
					</button>
					<Link to="/Admin/AdminErrorDashboard" className="btn btn-sm mt-0">
						<ion-icon name="desktop-outline"></ion-icon> {t('dashboard.title')}
					</Link>
				</div>
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				{(viewTree && user.adminType != "U") &&
					<div className={viewTree ? "section fl p-0" : "section p-0 fl"} style={{ width: wHg }}>
						<div className='p-1'>
							<RayTreeview onClickItem={onChangeTreeviewItem} onResize={setwHg} stateKey={LIST_STATE_KEYS.ADMIN_ERROR} />
						</div>
					</div>}
				<div className="section m-1 p-0">
					<div className="card p-2">
						<div className={user.adminType != "U" ? "fl" : ""}
							style={viewTree && user.adminType != "U" ? { width: wAll - (viewTree ? 354 : 68) } : {}}>
							<div className="mb-1">
								{[
									{ code: null, title: t('common.label.all') },
									{ code: 'URGENT', title: '🔴 ' + t('common.status.urgent') },
									{ code: 'FAVORITE', title: '⭐ ' + t('common.status.favorite') },
									{ code: 'NORMAL', title: '🟢 ' + t('common.status.normal') },
								].map(p => (
									<button
										key={p.code || 'all'}
										className={`btn btn-sm me-1 ${
											JSON.stringify(priorityFilter) === JSON.stringify(p.code ? { 'errs.priority': p.code } : {})
												? 'btn-primary' : 'btn-outline-secondary'
										}`}
										onClick={() => setPriorityFilter(p.code ? { 'errs.priority': p.code } : {})}
									>
										{p.title}
									</button>
								))}
							</div>
							{ready && <RayTable
								stateKey={LIST_STATE_KEYS.ADMIN_ERROR}
								key={JSON.stringify(priorityFilter)}
								data={enrichedData}
								addFilter={filterCompanyId}
								listtype="producterr"
								toggle={toggle}
								toggleval={getMatchToggle()}
								exportlocalaction={ProductAction.GetErrorListLocal}
								exheader={exheader.map(x => x.code)}
								checkBoxCallback={(list) => checkedList(list)}
								columns={header}
								options={options}
								onClear={clearPriorityFilter}
								bulkActions={bulkActions}
								bulkActionDo={handleBulkAction}
							/>}
						</div>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
			<CustomHeader
				extratrakey={"PRODUCTEXTRAKEY"}
				title={"Product Error List Header"}
				extratrakeyname={"extradata"}
				exHeader={exheader}
				adminheaderprefix={"errors"}
				showModal={showCHModal}
				callbackClose={() => setShowCHModal(false)}
				defaultFilter={defaultFilter}
				baseHeader={header} />
		</>
	);
};

const mapState = (state) => {
	const user = state.AuthReducer.user;
	const su = state.AuthReducer.su;
	const viewTree = state.ProgramReducer.viewtree;
	const companies = state.CompanyReducer.companies;
	const producterrs = state.ProductReducer.producterrs;
	const totalproducterrcount = state.ProductReducer.totalproducterrcount;
	const filterErrOptions = state.ProductReducer.filterErrOptions;
	const filterDateOptions = state.ProductReducer.filterErrDateOptions;
	const producterrsmatch = state.ProductReducer.producterrsmatch;
	const errfilters = state.ProductReducer.errfilters;
	const errsort = state.ProductReducer.errsort;
	return { user, su, producterrs, totalproducterrcount, producterrsmatch, filterErrOptions, errfilters, errsort, filterDateOptions, viewTree, companies };
};

const mapDispatch = (dispatch) => ({
	GetErrorList: (filter, showtype) => dispatch(ProductAction.GetAllErrorList(filter, showtype)),
	CloseProductError: (sn, errInfo, extra, options) => dispatch(ProductAction.CloseProductError(sn, errInfo, extra, options)),
	AddErrorMailException: (sn, errorCode, desc) => dispatch(ProductAction.AddErrorMailException(sn, errorCode, desc)),
	RemoveErrorMailException: (sn, errorCode) => dispatch(ProductAction.RemoveErrorMailException(sn, errorCode)),
	BatchCheckMailExceptions: (items) => dispatch(ProductAction.BatchCheckMailExceptions(items)),
});

export default connect(mapState, mapDispatch)(AdminErrorList);
